{
    "OptionsMenuTitle": "Show the available options for this dashboard sub report.",
    "DashboardDraggableTitle": "Drag this onto another report in this dashboard to swap places.",
    "OptionsMenuRemove": "Remove Report",
    "OptionsMenuAdd": "Create New Report",
    "OptionsMenuModify": "Modify Report",
    "OptionsMenuChange": "Switch Report",
    "OptionsMenuChoose": "Choose Report",
    "OptionMenuUpdateReportError": "There was an error trying to update the dashboard report.",
    "OptionMenuRemovePermDelete": "Permanently delete this report",
    "NAME": "DashboardOptions"
}